import { CommonModule } from '@angular/common';
import { Component, effect, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ActionBtnComponent } from 'src/app/shared/components/master-detail-layout/action-btn/action-btn.component';
import { CardComponent } from 'src/app/shared/components/master-detail-layout/card/card.component';
import { PrintersModuleService } from '../../../services/printers-module.service';
import { Printers } from 'tilby-models';
import { PrintersFormGroups } from '../../../models/settings-printers.model';
import { PrinterFormService } from '../../../services/printer-form.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-printer-configuration',
  standalone: true,
  imports: [
    CommonModule,
    CardComponent,
    ActionBtnComponent,
    MatFormFieldModule, ReactiveFormsModule,
    TranslateModule
  ],
  templateUrl: './printer-configuration.component.html',
  styleUrl: './printer-configuration.component.scss'
})
export class PrinterConfigurationComponent {
  
  private readonly printerModuleService = inject(PrintersModuleService);
  protected readonly printerFormService = inject(PrinterFormService);  

  protected printerGroupForm!: PrintersFormGroups;
  protected printer: Printers | null = null;
  protected options: any = null;

  protected readonly headerLineNumbers = Array.from({ length: 13 }, (_, i) => i + 1);
  protected readonly vats = this.printerModuleService.vat;
  protected readonly departments = this.printerModuleService.departments;
  protected readonly paymentMethods = this.printerModuleService.paymentMethods;

  protected showGeneralCard = true;

  protected linearValueClass = "tw-font-medium tw-text-[var(--sys-text)]";
  
  protected linearLabelClass = "tw-font-medium tw-text-[var(--sys-secondary-text)]";
  protected priceLabelNoMarginClass = "tw-text-[12px] tw-font-bold tw-tracking-wider tw-text-[var(--sys-secondary-text)]";
  protected priceValueClass = "tw-text-sm tw-font-medium tw-text-[var(--sys-text)]";
  
  protected priceLabelClass = "tw-text-[12px] tw-font-bold tw-tracking-wider tw-text-[var(--sys-secondary-text)] tw-mb-1";
  protected subTitleClass = "tw-text-sm tw-font-semibold tw-text-[var(--sys-secondary-text)] tw-tracking-wider";


  constructor() {
    effect(() => {
      if(this.printerFormService.printerFormReady()) {
        this.printerGroupForm = this.printerFormService.form;
        this.showGeneralCard = this.printerFormService.printerNumber?.value
            || this.printerFormService.displayMessage.value
            || this.printerFormService.sellerPrefix.value
            || this.printerFormService.tail.value
            || this.printerFormService.qrCodeMessage.value
            || this.printerFormService.qrCodeUrl.value;
      }
    })
    effect(() => {
      this.printer = this.printerModuleService.selection()?.printer as Printers;
      this.options = this.printerModuleService.selection()?.options;
    })
  }
}
